<label class="checkbox-container" [class.disabled]="isDisabled()">
  <input
    type="checkbox"
    [checked]="checked()"
    [disabled]="isDisabled()"
    (change)="toggle($event)"
  />
  <span class="checkmark"></span>
  <span class="label-text"><ng-content /></span>
</label>
